<template>
  <v-container>
    <v-card>
      <v-card-title>
        Статистика системы
        <div class="spacer"></div>
        <div>
          <v-btn class="white--text" icon small @click="fetch">
            <v-icon>refresh</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-card-text>
        <div v-if="system" class="my-2">
          <h3>Статистика базы</h3>
          <div>Публикаций: {{ system.db.publications.count }}</div>
          <div>Публикаций за последний час: {{ system.db.publications.last1h }}</div>
          <div>Источников: {{ system.db.sources.count }}</div>
        </div>
        <div v-if="isAdmin && celery" class="my-2">
          <h3>Очереди Celery</h3>
          <div>Celery ingress: {{ celery.queues.ingress.number }}</div>
          <div>Celery crawler: {{ celery.queues.crawler.number }}</div>
          <div>Celery scrapy: {{ celery.queues.scrapy.number }}</div>
          <div>Celery general: {{ celery.queues.general.number }}</div>
        </div>
        <div v-if="isAdmin && yandexCloud" class="my-2">
          <h3>Очереди Yandex</h3>
          <div>Yandex DATA: {{ yandexCloud.queues.data.number }}</div>
          <div>Yandex CONTROL: {{ yandexCloud.queues.control.number }}</div>
        </div>
        <div v-if="isAdmin && elastic" class="my-2">
          <h3>Метрики ElasticSearch</h3>
          <vue-json-pretty :data="elastic.stats.indices.publication" :deep="2" />
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty'

export default {
  components: {
    VueJsonPretty,
  },
  data: () => {
    return {
      API: 'stats/',
      celery: null,
      yandexCloud: null,
      elastic: null,
      system: null,
    }
  },
  computed: {
    isAdmin() {
      return this.$store.getters['auth/isAdmin']
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      this.$axios.$get('/metrics/celery/').then(
        response => {
          this.celery = response
        },
        () => {
          this.$toastError.fire({ title: 'Ошибка получения статистики системы' })
        },
      )
      this.$axios.$get('/metrics/yc/').then(
        response => {
          this.yandexCloud = response
        },
        () => {
          this.$toastError.fire({ title: 'Ошибка получения статистики системы' })
        },
      )
      this.$axios.$get('/metrics/es-internals/').then(
        response => {
          this.elastic = response
        },
        () => {
          this.$toastError.fire({ title: 'Ошибка получения статистики системы' })
        },
      )
      this.$axios.$get('/metrics/system/').then(
        response => {
          this.system = response
        },
        () => {
          this.$toastError.fire({ title: 'Ошибка получения статистики системы' })
        },
      )
    },
  },
}
</script>

<style></style>
